type EmblemEnv = "production" | "uat" | "emUAT" | "staging" | "development";

const REGISTER_URLS: Record<EmblemEnv, string> = {
  production:
    "https://my.emblemhealth.com/member/s/register-user?c__showCloseMessage=true",
  uat: "https://my-qa.emblemhealth.com/member/s/register-user?c__showCloseMessage=true",
  emUAT:
    "https://my-uat.emblemhealth.com/member/s/register-user?c__showCloseMessage=true",
  staging:
    "https://my-dev.emblemhealth.com/member/s/register-user?c__showCloseMessage=true",
  development:
    "https://my-dev.emblemhealth.com/member/s/register-user?c__showCloseMessage=true",
};

export const getMemberRegisterUrl = (): string => {
  const env = (import.meta.env.VITE_APP_ENV ?? "development") as EmblemEnv;
  return REGISTER_URLS[env] ?? REGISTER_URLS.development;
};
